import { ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";

export function OfficeDrawerLink({
  officeId,
  children,
}: {
  officeId: string;
  children: ReactNode;
}) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="underline"
      onClick={() =>
        navigate({
          to: ".",
          search: (prev: any) => ({
            ...prev,
            officeId,
          }),
        })
      }
    >
      {children}
    </button>
  );
}
